export default __webpack_public_path__ + "static/media/sort-ascending.31969258.svg";